import React from 'react';
import { CustomerActivityModelExtended } from '../../customer/model/CustomerActivityModel';
import './ActivitySummaryItem.scss'
import { Column, Icon, Row } from '../../components';
import { IconType } from '../../components/components/Icon/interfaces';
import moment from 'moment';
import { CommonUtility } from "../../Services/CommonUtility";
import ActivityDashboardService from './ActivityDasboardService';

export interface IActivitySummaryItem {
    activityItem : CustomerActivityModelExtended,
    navigateTo : (path : string) => void
}

const ActivitySummaryItem : React.FunctionComponent<IActivitySummaryItem>  = (props) => {

    let activityDashboardService  = new ActivityDashboardService();
    let iconType  = activityDashboardService.getPolicyTypeIcon(props.activityItem.policyTypeId);
    
    const timeAgo = moment(moment(props.activityItem.activityEffDateFormatted).format('MM/DD/YYYY')).fromNow();

    return <div className='activity-summary--main-div'>
        <Row noGutters={true}>
            <Column lg={1} md={1}>
                <div className='activity-summary--icon-div'>
                    <div>
                        {iconType && 
                            <Icon icon={iconType as IconType} 
                                className={'activity-summary--item-icon'}
                                title={iconType ? iconType : ''}/>
                        }
                    </div>
                </div>
            </Column>
            <Column lg={7} md={7}>
                <div className='activity-summary--detail'>
                    <div className='activity-summary--customer'>
                        {props.activityItem.customer}
                    </div>
                    <div className='activity-summary--content activity-summary--secondary-content'>
                        {props.activityItem.descriptionFormatted}
                    </div>
                </div>
            </Column>
            <Column lg={3} md={3}>
                    <div className='activity-summary--secondary-content activity-summary--center'>
                        {props.activityItem.activityEffDateFormatted}
                    <div className='activity-summary--time-span'> {timeAgo.includes('day') || timeAgo.includes('month') || timeAgo.includes('year') ? timeAgo : 'Today'} </div>                    </div>
            </Column>
            <Column lg={1} md={1}>
                <div className='task-summary--task-screen-arrow-div'>
                    <div>
                        <Icon icon={'right-arrow' as IconType} onClick={() => props.navigateTo(`/customer-view/activity/${props.activityItem.custId}`)}
                            className={'task-summary--item-icon'}/>
                    </div>
                </div>
            </Column>
        </Row>
    </div>;
}

export default ActivitySummaryItem;